import {
  Body,
  WalletButton,
  Container,
  Header,
  MainScreen,
  Logo,
  AppName,
} from "./components";
import { NetworkModal } from "./components";
import logo from "./DegenDefi.png";

function App() {
  return (
    <Container>
      <Header>
        <Logo src={logo} alt="ethereum-logo" />
        <AppName>DegenDeFi</AppName>
        <WalletButton />
      </Header>
      <Body>
        <NetworkModal />
        <MainScreen />
      </Body>
    </Container>
  );
}

export default App;
